// extracted by mini-css-extract-plugin
export var allBtn = "main-module--all-btn--26bb7";
export var licenses = "main-module--licenses--9c35f";
export var licenses__title = "main-module--licenses__title--51e7a";
export var mainBtn = "main-module--main-btn--b305b";
export var mainTitle = "main-module--main-title--64ac9";
export var rocket = "main-module--rocket--01467";